import type { Building } from "building-types/building/buildingTypes";
import type { Doc } from "building-types/doc";
import { EMPTY_INSTANCE_OPTION_SETS } from "building-types/doc/docDefaultConstants";
import type { OptionDefinitions } from "building-types/options/optionDefinitions";

// Converts a doc slice to OptionDefinitions.
export function partialDocToOptionDefinitions(doc: Pick<Doc, "optionSets" | "instanceOptionSets">): OptionDefinitions {
  return {
    optionSets: doc.optionSets,
    instanceOptionSets: doc.instanceOptionSets,
  };
}

// Converts a doc to OptionDefinitions.
export function docToOptionDefinitions(doc: Doc): OptionDefinitions {
  return partialDocToOptionDefinitions(doc);
}

/**
 * Option definitions for a generated building: evaluated archetype option sets when present,
 * instance join rows from the doc.
 */
export function buildingOptionDefinitions(building: Pick<Building, "doc" | "evaluatedOptionSets">): OptionDefinitions {
  return {
    optionSets: building.evaluatedOptionSets ?? building.doc.optionSets,
    instanceOptionSets: building.doc.instanceOptionSets ?? EMPTY_INSTANCE_OPTION_SETS,
  };
}
